import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VContainer, VRow, VCol, VSheet, VSimpleTable, VAlert } from "vuetify/lib";
import CodePreview from '../../components/CodePreview.vue';
import BeosPlaygroundSection from '../../components/BeosPlaygroundSection.vue';
// Controladores de visibilidad para JSON de items
export default /*#__PURE__*/ _defineComponent({
    __name: 'BeosAutocompleteDemo',
    setup(__props) {
        const showItemsUsoBasico = ref(false);
        const showItemsStates = ref(false);
        const showItemsVariantes = ref(false);
        const showItemsAgrupacion = ref(false);
        const showItemsTexto = ref(false);
        const showItemsClases = ref(false);
        const showItemsChipConfig = ref(false);
        const value1 = ref(null);
        const value2 = ref([1, 2]);
        const value3 = ref(null);
        const value4 = ref([1, 2, 3]);
        const value5 = ref(null);
        const categories = ref([]);
        const items = [
            { id: 1, name: "Item 1", abreviation: "IT1", color: "#8100D1", colors: { background: "#8100D1", text: "#FFFFFF" } },
            { id: 2, name: "Item 2", abreviation: "IT2", color: "#F68048", colors: { background: "#F68048", text: "#FFFFFF" } },
            { id: 3, name: "Item 3", abreviation: "IT3", color: "#FF5B5B", colors: { background: "#FF5B5B", text: "#FFFFFF" } },
            { id: 4, name: "Item 4", abreviation: "IT4", color: "#685AFF", colors: { background: "#685AFF", text: "#FFFFFF" } },
            { id: 5, name: "Item 1", abreviation: "IT1", color: "#8100D1", colors: { background: "#8100D1", text: "#FFFFFF" } },
            { id: 6, name: "Item 2", abreviation: "IT2", color: "#F68048", colors: { background: "#F68048", text: "#FFFFFF" } },
            { id: 7, name: "Item 3", abreviation: "IT3", color: "#FF5B5B", colors: { background: "#FF5B5B", text: "#FFFFFF" } },
            { id: 8, name: "Item 4", abreviation: "IT4", color: "#685AFF", colors: { background: "#685AFF", text: "#FFFFFF" } },
        ];
        const items2 = [
            { id: 1, name: "Item 1", abreviation: "IT1", color: "#8100D1" },
            { id: 2, name: "Item 2", abreviation: "IT2", color: "#F68048" },
            { id: 3, name: "Item 3", abreviation: "IT3", color: "#FF5B5B" },
            { id: 4, name: "Item 4", abreviation: "IT4", color: "#685AFF" },
        ];
        const itemsWithHeaders = [
            { header: 'Frontend' },
            { id: 1, name: 'Vue.js', group: 'Frontend' },
            { id: 2, name: 'React', group: 'Frontend' },
            { header: 'Backend' },
            { id: 3, name: 'Node.js', group: 'Backend' },
            { id: 4, name: 'Python', group: 'Backend' },
        ];
        const chipConfig = {
            close: true,
            color: "primary",
            textColor: "white",
            textLength: 15,
            maxLength: 4,
            plusContentDisplay: {
                type: "tooltip",
                show: true,
            },
            style: (item) => {
                var _a, _b;
                return ({
                    backgroundColor: ((_a = item.colors) === null || _a === void 0 ? void 0 : _a.background) || "primary",
                    color: ((_b = item.colors) === null || _b === void 0 ? void 0 : _b.text) || "white",
                });
            },
        };
        const demoChipConfig = {
            close: true,
            maxLength: 2,
            plusContentDisplay: {
                type: 'menu',
                show: true
            },
            style: (item) => ({
                backgroundColor: '#673AB7',
                color: 'white',
                borderRadius: '4px'
            }),
            formatChipText: (item) => { var _a; return `${(_a = item.name) === null || _a === void 0 ? void 0 : _a.toUpperCase()} (ID: ${item.id})`; },
        };
        const demoChipConfigString = `// Prop: :chip-config="config"
{
  close: true,
  maxLength: 2,
  plusContentDisplay: {
    type: 'menu',
    show: true
  },
  style: (item) => ({
    backgroundColor: '#673AB7',
    color: 'white',
    borderRadius: '4px'
  }),
  formatChipText: (item) => \`\${item.name?.toUpperCase()} (ID: \${item.id})\`
}`;
        const getItemClass = (item) => {
            return item.id % 2 === 0 ? 'blue-item' : '';
        };
        const getItemClassString = `// Prop: :item-class="getItemClass"
const getItemClass = (item: any) => {
  return item.id % 2 === 0 ? 'blue-item' : '';
};`;
        return { __sfc: true, showItemsUsoBasico, showItemsStates, showItemsVariantes, showItemsAgrupacion, showItemsTexto, showItemsClases, showItemsChipConfig, value1, value2, value3, value4, value5, categories, items, items2, itemsWithHeaders, chipConfig, demoChipConfig, demoChipConfigString, getItemClass, getItemClassString, VContainer, VRow, VCol, VSheet, VSimpleTable, VAlert, CodePreview, BeosPlaygroundSection };
    }
});
